import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { formatDate } from "../../config/Config";
import DocumentTypesService from "../../services/DocumentsService";
import { helper } from "../../componets/utils/helper";
import { CandidateDBContext } from "./CandidateDBContext";
import { candidateService } from "../../services/CandidateService";
import ScreenLoader from "../../componets/ScreenLoader";
import { AppDB } from "../../App";
import GenericFileCapture from "../../componets/GenericFileCapture";

export default function ({ header = null }) {
	var { selectedCanditate, setSelectedCanditate } = useContext(CandidateDBContext);
	var { toast } = useContext(AppDB);
	var { lookUp } = useContext(AppDB);
	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);

	var [loading, setLoading] = useState(true);
	var [refresh, setRefresh] = useState(true);
	var [documents, setDocuments] = useState([]);
	var [candidateDocumentTypes, setCandidateDocuments] = useState([]);

	const inputFileRef = useRef(null);
	const onBtnClick = () => {
		inputFileRef.current.value = "";
		inputFileRef.current.click();
	};

	var doc = new DocumentTypesService();

	useEffect(() => {
		doc.getDocumentTypes(5).then((res) => {
			setCandidateDocuments(res);
		});
	}, []);

	useEffect(() => {
		setLoading(true);
		candidateService.getDocumentsByCandidates(selectedCanditate.candidateID).then((res) => {
			setDocuments(res?.documents);
			setLoading(false);
		});
	}, [refresh]);
	var convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};
			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	return (
		<>
			<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
				{header !== null && <h5>{header}</h5>}
			</div>
			<ScreenLoader visible={loading} />

			<GenericFileCapture
				dontClearDocuments={false}
				refresh={refresh}
				setRefresh={setRefresh}
				requestCall={candidateService.addCandidateDocument}
				key={JSON.stringify(selectedCanditate)}
				extraAttributes={{
					candidateID: selectedCanditate.candidateID,
					eventID: selectedCanditate.eventID
				}}
				documentTypesLookUp={candidateDocumentTypes}
				show={showFileUploader}
				setShow={setShowFileUploader}
				setDocuments={setFileUploaderDocuments}
				documents={fileUploaderDocuments}
			/>

			<div className="col-12  lg:col-3 my-2">
				<label htmlFor="description">Upload Document</label>
				<br />
				<>
					<Button label={"Upload"} onClick={() => setShowFileUploader(true)} className="p-button-success" icon={"pi pi-plus"} />
				</>
			</div>

			<DataTable
				className="remove-border"
				size="small"
				scrollable={true}
				value={documents}
				dataKey="id"
				loading={loading}
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
				<Column header={"Title"} field="title"></Column>
				<Column header={"Document Type"} field="documentType"></Column>
				<Column header={"Created Date"} body={(row) => formatDate(row.createdDate)}></Column>
				<Column
					header={"Action"}
					field="Action"
					body={(row) => (
						<Button
							style={{
								textAlign: "center",
								width: "30px",
								height: "30px"
							}}
							icon={"pi pi-download"}
							tooltipOptions={{ position: "top" }}
							className="p-button-primary p-button-rounded mr-2"
							tooltip="Click to download"
							onClick={(e) => {
								e.stopPropagation();
								setLoading(true);
								doc.downloadDocument(row.documentID).then((res) => {
									setLoading(false);
								});
							}}
						/>
					)}
				></Column>
			</DataTable>
		</>
	);
}
